<script>
	import { onMount } from 'svelte';

	export let tag;
	export let meta;
	export let html;
	export let attributes = {};

	let div;
	const noReplacementNeededTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'pre', 'img', 'a'];
	const noReplacementNeededClasses = ['no_child_replacement', 'submit_done'];

	let newDiv = false;
	
	function generateTempDivFromOuterTag() {
		newDiv = document.createElement(tag);
		Object.values(attributes).forEach(attribute => {
			newDiv.setAttribute(attribute.name, attribute.value);
		});
	}
	
	// avoid rendering e.g. buttons inside buttons:
	function checkIfNoReplacementNeededByClass() {
		generateTempDivFromOuterTag();
		if(Array.from(newDiv.classList).length === 0) {
			return false;
		}
		return Array.from(newDiv.classList).find(divClass => noReplacementNeededClasses.includes(divClass));
	}
	
	onMount(() => {
		if(!div) {
			return;
		}
		generateTempDivFromOuterTag();
		while (div.firstChild) {
			newDiv.appendChild(div.firstChild);
		}
		div.parentNode.replaceChild(newDiv, div);
	});
</script>

{#if noReplacementNeededTags.includes(tag) || checkIfNoReplacementNeededByClass()}
	<slot/>
{:else}
	<!-- renders stuff like DIVs in DIVs, which is necessary some times: -->
	<div bind:this={div}>
		<slot/>
	</div>
{/if}
